<template>
  <div class="flex w-full account-page">
    <!-- <vs-alert color="danger" title="" :active.sync="displayUserNotFound">
            <span>Dados não encontrado. </span>
        </vs-alert> -->

    <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" class="h-full" style="padding-top: 15px; padding-right: 10px;">
          <vx-card title="" class="mb-base h-full card-account-info">
            <div class="avatar-users mt-5">
              <vs-avatar :text="getUserName" class="avatar center"></vs-avatar>
              <h4>{{ username }}</h4>
              <div class="badge-name-signature vs-chip-success con-color">
                <span v-if="language">{{ profile }}</span>
              </div>
            </div>
            <div class="p-4 flex">
              <h4>{{ $t('USER').Details }}</h4>
              <!-- <vx-tooltip text="editar dados" position="right" delay=".1s">
                <vs-button
                  class="ml-1"
                  radius
                  size="small"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-edit"
                  @click="openAttendanceEditData"
                >
                </vs-button>
              </vx-tooltip> -->
            </div>
            <div class="users-details pt-0 p-4">
              <div><b>{{ $t('USER').Email }}</b> {{ email }}</div>
              <div><b>{{ $t('USER').Name }}</b>: {{ username }}</div>
              <div><b>{{ $t('USER').Profile }}</b> {{ profile }}</div>
              <div><b>{{ $t('USER').Document }}</b> {{ cnpj_cpf }}</div>
              <div v-if="phone"><b>{{ $t('USER').Phone }}</b> {{ phone }}</div>
              <div><b>{{ $t('USER').Country }}</b> {{ country }}</div>
              <p class="mt-1"><vs-button class="ml-1" size="small" type="filled" icon-pack="feather" icon="icon-edit" @click="openAttendanceEditData" > {{ $t('BUTTONS').Edit_Data }} </vs-button></p>
              <p><vs-button color="danger" class="w-full mt-5" @click="onDeleteAccount" aria-disabled="true" type="filled" icon-pack="feather" icon="icon-trash">{{$t('DELETE_ACCOUNT').Delete_Account_Button}}</vs-button></p>
            </div>
          </vx-card>
        </vs-col>

        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9" class="h-full">
          <div v-if="language" class="vx-card account">
            <vs-tabs :position="'top'" class="p-5 h-full" v-model="tabIndex">
              <!-- GENERAL -->
              <!-- <vs-tab icon-pack="feather" icon="icon-user" :label="$t('NAVBAR_DROPDOWN_MENU').Profile">
                          <div class="tab-general mt-0 ml-0">
                              
                          </div>
                      </vs-tab> -->
               <vs-tab
                icon-pack="feather"
                icon="icon-bell"
                :label="$t('NAVBAR_DROPDOWN_MENU').Notification"
              >
                <user-notification></user-notification>
              </vs-tab>
              <vs-tab
                v-if="!canDisplayOnMobileIOS"
                icon-pack="feather"
                icon="icon-shopping-bag"
                :label="$t('NAVBAR_DROPDOWN_MENU').Signatures"
              >
                <div class="user-signature h-full">
                  <user-signatures @open-packages="tabIndex = 0"></user-signatures>
                </div>
              </vs-tab>
            <vs-tab
                v-if="!canDisplayOnMobileIOS"
                icon-pack="feather"
                icon="icon-shopping-bag"
                :label="$t('NAVBAR_DROPDOWN_MENU').Packages"
              >
                <div class="">
                  <packages></packages>
                </div>
              </vs-tab> 
              <vs-tab
                icon-pack="feather"
                icon="icon-key"
                :label="$t('NAVBAR_DROPDOWN_MENU').Change_Password"
              >
                <div class="">
                  <change-password></change-password>
                </div>
              </vs-tab>
              <!-- <vs-tab
                icon-pack="feather"
                icon="icon-shield"
                :label="$t('NAVBAR_DROPDOWN_MENU').Privacy_Policy"
              >
                <div class="h-full">
                  <privacy-policy></privacy-policy>
                </div>
              </vs-tab>-->
            </vs-tabs>
          </div>
        </vs-col>
    </vs-row>

    <!-- <div class="m-4 vx-col w-full lg:w-1/2">
      <vx-card title="" class="mb-base h-full">
        <div class="avatar-users mt-5">
          <vs-avatar :text="getUserName" class="avatar center"></vs-avatar>
          <h4>{{ username }}</h4>
          <div class="badge-name-signature vs-chip-success con-color">
            <span v-if="language">{{ profile }}</span>
          </div>
        </div>
        <div class="p-4">
          <h4>{{ $t('USER').Details }}</h4>
        </div>
        <div class="users-details pt-0 p-4">
          <div><b>{{ $t('USER').Email }}</b> {{ email }}</div>
          <div><b>{{ $t('USER').Name }}</b>: {{ username }}</div>
          <div><b>{{ $t('USER').Profile }}</b> {{ profile }}</div>
          <div><b>{{ $t('USER').Document }}</b> {{ cnpj_cpf }}</div>
          <div v-if="phone"><b>{{ $t('USER').Phone }}</b> {{ phone }}</div>
          <div><b>{{ $t('USER').Country }}</b> {{ country }}</div>
          <div><vs-button color="danger" class="w-full mt-5" @click="onDeleteAccount" aria-disabled="true" type="filled" icon-pack="feather" icon="icon-trash">{{$t('DELETE_ACCOUNT').Delete_Account_Button}}</vs-button></div>
        </div>
      </vx-card>
    </div> -->

    <!-- <div class="m-4 vx-col w-full lg:w-1/1">
      <div v-if="language" class="vx-card account">
        <vs-tabs :position="'top'" class="p-5 h-full" v-model="tabIndex">
          <vs-tab
            v-if="!canDisplayOnMobileIOS"
            icon-pack="feather"
            icon="icon-shopping-bag"
            :label="$t('NAVBAR_DROPDOWN_MENU').Signatures"
          >
            <div class="user-signature h-full">
              <user-signatures @open-packages="tabIndex = 1"></user-signatures>
            </div>
          </vs-tab>
        <vs-tab
            v-if="!canDisplayOnMobileIOS"
            icon-pack="feather"
            icon="icon-shopping-bag"
            :label="$t('NAVBAR_DROPDOWN_MENU').Packages"
          >
            <div class="">
              <packages></packages>
            </div>
          </vs-tab> 
          <vs-tab
            icon-pack="feather"
            icon="icon-bell"
            :label="$t('NAVBAR_DROPDOWN_MENU').Notification"
          >
            <user-notification></user-notification>
          </vs-tab>
          <vs-tab
            icon-pack="feather"
            icon="icon-key"
            :label="$t('NAVBAR_DROPDOWN_MENU').Change_Password"
          >
            <div class="">
              <change-password></change-password>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div> -->
          <!-- <vs-tab
            icon-pack="feather"
            icon="icon-shield"
            :label="$t('NAVBAR_DROPDOWN_MENU').Privacy_Policy"
          >
            <div class="h-full">
              <privacy-policy></privacy-policy>
            </div>
          </vs-tab>-->
  </div>
</template>

<script>
import AppConstants from '../../appConstants';
import { SYSTEM_SERVER_ERROR_CODE } from '../../enums/enum-system-server-error-code';
import { EventBus } from '../../event-bus';
import formatFieldHelper from "../../helpers/format-field-helper";
import messageDialogHelper from '../../helpers/message-dialog-helper';
import authService from '../../providers/authService';
import userService from "../../providers/userService";
import ChangePassword from "./ChangePassword.vue";
import PrivacyPolicy from "./help/PrivacyPolicy.vue";
import Packages from './Packages.vue';
import UserNotification from "./UserNotification.vue";
import UserSignatures from "./UserSignatures.vue";

export default {
  components: {
    UserSignatures,
    UserNotification,
    ChangePassword,
    PrivacyPolicy,
    Packages
  },
  data() {
    return {
      displayUserNotFound: false,
      tabIndex: 0,
      email: "",
      username: "",
      country: "",
      cnpj_cpf: "",
      phone: "",
      profile: "",
      language: true,
    };
  },
  created() {
    this.loadUserData();
    this.changeTabIndexByParams(this.$route.params.tab);
  },
  watch: {
    tabIndex(val) {
      switch (val) {
        case 0:
          this.$router.push({ params: { tab: "notification" } });
          break;
        case 1:
          this.$router.push({ params: { tab: "signature" } });
          break;
        case 2:
          this.$router.push({ params: { tab: "packages" } });
          break;
        case 3:
          this.$router.push({ params: { tab: "change-password" } });
          break;
        case 4:
          this.$router.push({ params: { tab: "privacy-policy" } });
          break;
      }
    },
    "$i18n.locale"(value) {
      // TODO FELIPE
      // userService.updateUser(new URLSearchParams(), {language: value});
      if (AppConstants.USER_PROFILE.SUBSCRIBER) {
        this.profile = this.$t('USER_PROFILE').Subscriber;
      } 
      if (AppConstants.USER_PROFILE.DEMO) {
        this.profile = this.$t('USER_PROFILE').Demo;
      }
      if (AppConstants.USER_PROFILE.FREE) {
        this.profile = this.$t('USER_PROFILE').Free;  
      }
      this.language = false;
      // multi language - when change value request new data from server
      setTimeout(() => {
        this.language = true;
      }, 100);
      
    },
    "$route.params.tab"(val) {
      this.changeTabIndexByParams(val);
    }
  },
  computed: {
    canDisplayOnMobileIOS() {
      return this.$store.state.isMobileIOS;
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    getUserName() {
      if (!this.username) {
        return "";
      }
      const split = this.username.split(" ");
      return `${split[0]} ${split[split.length - 1]}`;
    },
    getPhoneFormatted() {
      return formatFieldHelper.formatFieldCellPhone(this.phone);
    }
  },
  methods: {
    openAttendanceEditData() {
      messageDialogHelper.displayEditAccountDataMessage(() => {
        EventBus.$emit(AppConstants.BUS_EVENT_OPENA_ATTENDANCE, this.$t('HELP_ATTENDANCE').Edit_Account_Data);
      });
    },
    onDeleteAccount() {
      messageDialogHelper.displayDialogConfirmCancelWithText(this.$t('DELETE_ACCOUNT').Title,this.$t('DELETE_ACCOUNT').First_Question,this.$t('DELETE_ACCOUNT').First_Question_Button_Decline,this.$t('DELETE_ACCOUNT').First_Question_Button_Continue, (callback) => {
        if (callback == 'cancel') {
          userService.deleteAccount(new URLSearchParams())
          .then(() => {
            messageDialogHelper.displayDialogAccept(this.$t('DELETE_ACCOUNT').First_Question_Success_Title, this.$t('DELETE_ACCOUNT').First_Question_Success_Text, () => {
              authService.logout();
            });
          })
          .catch(err => {
            if (err.code == SYSTEM_SERVER_ERROR_CODE.USER_CANNOT_DELETE.code) {
              messageDialogHelper.displayDialogAccept(this.$t('DELETE_ACCOUNT').Title,this.$t('DELETE_ACCOUNT').Cannot_Delete_Text, () => {});
            }
          });
        } 
      });
    },
    changeTabIndexByParams(params) {
      if (params) {
        switch (params) {
          case "notification":
            this.tabIndex = 0;
            break;
          case "signature":
            this.tabIndex = 1;
            break;
          case "packages":
            this.tabIndex = 2;
            break;
          case "change-password":
            this.tabIndex = 3;
            break;
          case "privacy-policy":
            this.tabIndex = 4;
            break;
        }
      }
    },
    loadUserData() {
      userService
        .getUserDetails(new URLSearchParams())
        .then(data => {
          this.email = data.email;
          this.username = data.name;
          this.country = data.country.name;
          this.cnpj_cpf = formatFieldHelper.formatDocument(data.cnpj_cpf);
          if (data.phone) {
            this.phone = formatFieldHelper.formatFieldCellPhone(data.phone.trim());
          }
          switch (data.profile) {
            case AppConstants.USER_PROFILE.SUBSCRIBER:
              this.profile = this.$t('USER_PROFILE').Subscriber;
              break;
            case AppConstants.USER_PROFILE.DEMO:
              this.profile = this.$t('USER_PROFILE').Demo;
              break;
            case AppConstants.USER_PROFILE.FREE:
              this.profile = this.$t('USER_PROFILE').Free;
              break;
          }
          // this.profile = data.profile;
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style lang="scss"></style>
